var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_vm.item.poptip ? _c('Poptip', {
    attrs: {
      "confirm": "",
      "transfer": "",
      "title": _vm.item.poptip.title,
      "placement": "left"
    },
    on: {
      "on-ok": _vm.onClick,
      "on-cancel": _vm.oncancel
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.title))])]) : _c('span', {
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v(_vm._s(_vm.item.title))])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };